import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DialogComponent } from './dialog.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: DialogComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class DialogRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/view/dialog/dialog-routing.module.ts